import { makeStylesV5 } from '../index';
const typoGraphyTextStyles = {
    color: 'var(--text-secondary, rgba(0, 0, 0, 0.60))',
    fontSize: '14px',
    fontFamily: 'Inter',
    fontWeight: 400,
    letterSpacing: '0.17px',
    lineHeight: '143%',
};
export const isFocusedOrDragAccepted = {
    borderWidth: '2px',
    borderColor: 'rgba(0, 92, 102, 0.50)',
    background: 'rgba(0, 92, 102, 0.04)',
};
export const isDragRejected = {
    borderWidth: '1px',
    borderColor: '#D91C03',
};
export default makeStylesV5()((theme) => ({
    labelWrapper: {
        fontFamily: 'Inter',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '12px',
        letterSpacing: '0.15px',
        marginBottom: '8px',
        '&.imagePreview': {
            marginBottom: '4px',
        }
    },
    imagePreviewWrapper: {
        display: 'flex',
        padding: '4px 0px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        borderRadius: '4px',
        '& .imageWrapper': {
            display: 'flex',
            maxHeight: '184px',
            padding: '8px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            borderRadius: '4px',
            border: '1px solid #BDBDBD',
            boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
            '& .image': {
                maxHeight: '170px',
                maxWidth: '170px',
                '&.defaultHeight': {
                    height: '170px',
                    width: '170px',
                }
            },
        },
    },
    dropzone: {
        border: `1px dashed rgba(0, 0, 0, 0.23)`,
        ['&:hover']: {
            borderColor: '#007A87',
        },
        boxSizing: 'border-box',
        padding: '24px 16px',
        marginBottom: '8px',
        height: '200px',
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        justifyContent: 'center',
        position: 'relative',
        '& .uploadLink': {
            color: theme.palette.primary.main,
            cursor: 'pointer',
            textDecoration: 'underline',
            fontFamily: 'Inter',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '175%',
            letterSpacing: '0.15px',
        },
        '&.error': {
            borderColor: theme.palette.error.main
        },
        '&.disabled': {
            opacity: 0.5,
            cursor: 'not-allowed'
        },
        '& .content-section': {
            textAlign: 'center',
            '& .content-icon': {
                fontSize: '48px',
                color: '#CFD8DC'
            },
            '& .text-section': {
                display: 'grid',
                gap: 5,
                textAlign: 'center',
                '& .typography-text': Object.assign({}, typoGraphyTextStyles)
            },
        }
    },
    fileValidationSection: {
        textAlign: 'center',
        maxWidth: 'calc(100% - 50px)',
    },
    acceptedFilesTypography: Object.assign(Object.assign({}, typoGraphyTextStyles), { textWrap: 'nowrap', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }),
    fileSpecsText: Object.assign(Object.assign({}, typoGraphyTextStyles), { fontSize: '12px', lineHeight: '166%', letterSpacing: '0.4px', textWrap: 'nowrap', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }),
    loadingSection: {
        padding: '4px 8px',
        background: '#FAFAFA',
        overflow: 'hidden',
        color: 'rgba(0, 0, 0, 0.38)',
        textOverflow: 'ellipsis',
        fontFamily: 'Inter',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '150%',
        letterSpacing: '0.15px',
        '& .content-loader': {
            color: '#9E9E9E',
            width: '16px !important',
            height: 'auto !important',
            textAlign: 'center',
            fontFamily: 'Font Awesome 6 Sharp',
            lineHeight: 'normal',
        },
    },
    errorMessageBox: {
        display: 'flex',
        justifyContent: 'flex-start',
        '& .error-message': {
            position: 'unset',
            textAlign: 'initial',
            marginTop: '0px',
            color: '#A31502',
            fontFamily: 'Inter',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '166%',
            letterSpacing: '0.4px',
        }
    },
}));
//# sourceMappingURL=styles.js.map